import { useState } from 'react';
import { parseModifier } from './methodVisuals';

const emptyForm = () => ({ label: '', priceModifier: 0 });

/**
 * Estado e validação do formulário de método de pagamento (PaymentMethodForm).
 * Usado pela tela de métodos (criar/editar) e pelo faturamento do agendamento
 * (cadastrar a primeira forma sem sair da agenda), para a regra ficar num lugar só.
 */
export function usePaymentMethodForm() {
  const [formData, setFormData] = useState(emptyForm);
  const [errors, setErrors] = useState({});

  /** Volta ao formulário vazio ou carrega um método existente para edição. */
  const reset = (method = null) => {
    setErrors({});
    setFormData(method ? {
      label: method.Label,
      priceModifier: String(parseModifier(method.PriceModifier) || 0).replace('.', ','),
    } : emptyForm());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // O ajuste fica como texto enquanto a pessoa digita (vazio, "-", "2,5"); vira número só ao salvar
    if (name === 'priceModifier' && !/^-?\d*[.,]?\d*$/.test(value)) return;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const next = {};
    if (!String(formData.label || '').trim()) next.label = 'Informe o nome do método';
    const modifier = parseModifier(formData.priceModifier);
    if (Number.isNaN(modifier) || modifier < -100 || modifier > 100) {
      next.priceModifier = 'Use um valor entre -100 e 100';
    }
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  /** Dados prontos para a API (nome sem espaços nas pontas, ajuste como número). */
  const payload = () => ({
    label: formData.label.trim(),
    priceModifier: parseModifier(formData.priceModifier),
  });

  return { formData, errors, handleChange, validate, payload, reset };
}

export default usePaymentMethodForm;
